export default {
  tab: {
    index: 'Theo Ngày',
    weekly: 'Theo Tuần',
    monthly: 'Theo Tháng',
    quarterly: 'Theo Quý',
    yearly: 'Theo Năm',
  },

  prospectItem: {
    usMarket: 'CHỨNG KHOÁN MỸ',
    euroMarket: 'CHỨNG KHOÁN CHÂU ÂU',
    asianMarket: 'CHỨNG KHOÁN CHÂU Á',
    oilWtiPrice: 'GIÁ DẦU WTI',
    centralBankRate: 'LÃI SUẤT LIÊN NH',
    worldGoldPrice: 'VÀNG THẾ GIỚI',
    vnIndex: 'VN-INDEX',
    foreignFlow: 'GIAO DỊCH NƯỚC NGOÀI',

    Up: 'TĂNG',
    Down: 'GIẢM',

    Price: 'Giá',
    PriceChange: 'Thay Đổi Giá',
    PercentPriceChange: '% Thay Đổi Giá',

    ExchangeRate: 'Tỷ Giá Hối Đoái',
    PreviousExchangeRate: 'Tỷ Giá Hối Đoái Trước Điều Chỉnh',

    IndexValue: 'Chỉ Số',
    IndexChange: 'Thay Đổi',
    PercentIndexChange: '% Thay Đổi',

    ForeignBuyValueMatched: 'GTNN Mua',
    ForeignSellValueMatched: 'GTNN Bán',
    NetForeign: 'GTNN Ròng',
  },
};
